import { render, staticRenderFns } from "./DetailTwo.vue?vue&type=template&id=3dc21dac&scoped=true"
import script from "./DetailTwo.vue?vue&type=script&lang=ts"
export * from "./DetailTwo.vue?vue&type=script&lang=ts"
import style0 from "./DetailTwo.vue?vue&type=style&index=0&id=3dc21dac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc21dac",
  null
  
)

export default component.exports